import React from 'react';
import { ReactComponent as Error } from '../../assets/images/icons/error.svg';

export default function ErrorIcon(props) {
  return (
    <Error className={`icon ${props.className}`} />
  );
}
